module.exports = __webpack_public_path__ + "img/pump-lg.a1ce38fa.svg";